// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__cZU1j","white-gradient":"DefaultLayout_white-gradient__foY8e"};